import fontManagerService from '@/utils/fontManagerService';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('SidebarWrapperCtrl', sidebarWrapperCtrl);

    function sidebarWrapperCtrl(
        $rootScope,
        $scope,
        $location,
        $mdDialog,
        $timeout,
        $window,
        UsersAPIService,
        AuthService
    ) {
        const getCurrentRoute = (path, queryParams) => {
            if ('forMyDesigns' in queryParams ? true : false) {
                return '/designs';
            }

            if ('forMyProductBases' in queryParams ? true : false) {
                return '/myProductBases';
            }

            if (path.indexOf('createProduct') > -1) {
                return '/home';
            }

            if (path.includes('/set/') || path.includes('/sets/')) {
                return '/store/sets/';
            }

            return path;
        };
        $scope.currentRoute = getCurrentRoute($location.path(), $location.search());
        // Listen for route changes
        $rootScope.$on('$routeChangeSuccess', function routeChangeHandler(event, current) {
            if (current && current.$$route && current.$$route.originalPath) {
                $scope.currentRoute = getCurrentRoute($location.path(), $location.search());
            }
        });

        // Impersonation variables
        $scope.usernames = [];
        $scope.isAdminUser = false;
        $scope.isParentUser = false;
        $scope.isChildUser = false;
        $scope.isSwitchTeamModalOpen = false;

        $scope.openSwitchTeamModal = function () {
            $scope.isSwitchTeamModalOpen = true;
        };

        $scope.onSwitchTeamModalVisibility = function (isOpen) {
            $scope.isSwitchTeamModalOpen = isOpen;
        };

        $scope.$on('route:success', async (_, user) => {
            if (!user) {
                return;
            }

            $scope.isAdminUser =
                (user?.AccessRoles?.Serialized?.split(',').includes('admin') || user?.ImpersonatedFromAdminUser) &&
                !user?.ImpersonatedFromChildUser;
            $scope.isParentUser =
                user?.AccessRoles?.Serialized?.split(',').includes('parent') ||
                user?.ImpersonatedFromParentUser ||
                false;
            $scope.isChildUser =
                user?.AccessRoles?.Serialized?.split(',').includes('impersonate-parent') ||
                user?.ImpersonatedFromChildUser ||
                false;

            if ($scope.isAdminUser || $scope.isParentUser || $scope.isChildUser) {
                $scope.usernames = await UsersAPIService.getAllUsernames();

                // If the user has only one access, impersonate automatically
                if ($scope.usernames.length == 1 && !$scope.user?.ImpersonatedFromChildUser) {
                    const usernameToImpersonate = $scope.usernames[0].Username;
                    if (usernameToImpersonate != $scope.user?.Username) {
                        await $scope.changeUser(usernameToImpersonate);
                        return;
                    }
                }

                $scope.selectedUser = user?.Username;
                $scope.impersonateUser = '';
                $timeout(() => $scope.$apply());
            }
        });

        $scope.changeUser = async function (username) {
            if (username) {
                $scope.isLoading = true;
                await UsersAPIService.impersonate(username);

                // Clear fonts so fonts from the new user are loaded
                fontManagerService.clearFontsCache();

                $window.location.reload();
                $scope.isLoading = true;
            }
        };

        $scope.openDialog = function ($event) {
            $mdDialog.show({
                controller: function ($scope, usernames, selectedUser, user, isAdminUser, impersonateUser) {
                    $scope.usernames = usernames;
                    $scope.userSearchText = '';
                    $scope.selectedUser = selectedUser;
                    $scope.user = user;
                    $scope.isAdminUser = isAdminUser;
                    $scope.impersonateUser = impersonateUser;
                    $scope.selectedParentUsername = null;
                    $scope.isLoading = false;
                    $scope.mdClose =
                        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=';

                    $scope.hasParentUsername = function (item) {
                        return item && item.ParentUsername && item.ParentUsername.length > 0;
                    };

                    $scope.usernameQuerySearch = function (query) {
                        const filteredUsernames = $scope.usernames.filter(function (username) {
                            return (username.Username || '').toLowerCase().includes((query || '').toLowerCase());
                        });
                        const sortedUsernames = filteredUsernames.sort((a, b) => {
                            return a.Username?.localeCompare(b.Username, undefined, { sensitivity: 'base' });
                        });
                        return sortedUsernames;
                    };
                    $scope.changeUser = async function () {
                        if ($scope.impersonateUser) {
                            $scope.isLoading = true;
                            await UsersAPIService.impersonate($scope.impersonateUser);

                            // Clear fonts so fonts from the new user are loaded
                            fontManagerService.clearFontsCache();

                            $window.location.reload();
                            $scope.isLoading = true;
                        }
                    };
                    $scope.setImpersonateUser = async function (item) {
                        if (item) {
                            // If it's a team member (has valid ParentUsername), impersonate the parent instead
                            if ($scope.hasParentUsername(item)) {
                                $scope.impersonateUser = item.ParentUsername;
                                $scope.selectedParentUsername = item.ParentUsername;
                            } else {
                                $scope.impersonateUser = item.Username;
                                $scope.selectedParentUsername = null;
                            }
                        }
                    };
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
                locals: {
                    usernames: $scope.usernames,
                    selectedUser: $scope.selectedUser,
                    user: $scope.user,
                    isAdminUser: $scope.isAdminUser,
                    impersonateUser: $scope.impersonateUser
                },
                template: require('../../../views/impersonateUserDialog.html'),
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };

        $scope.logout = function () {
            const confirm = $mdDialog
                .confirm()
                .title('Logout')
                .textContent('Do you want to logout?')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(() => {
                AuthService.logout();

                // Clear user data
                $rootScope.user = undefined;
            });
        };
    }
})();
